import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

export interface Props {
  classNames?: string[]
  children: React.ReactNode
}

// TODO maybe we can merge this with MaterialActivationLayout?
const MessagesSplitLayout = ({classNames, children}: Props) => (
  <div className={cn('MessagesSplitLayout', {}, classNames)}>{children}</div>
)

export default MessagesSplitLayout
